module.exports = __webpack_public_path__ + "img/certificate_template_cat2.7840686f.jpg";